// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const content = "ContentsBased__content__gbRUt font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const heading = "ContentsBased__heading__zRFzT";
export const headingCaption = "ContentsBased__headingCaption__K6mwd font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const inlineParagraph = "ContentsBased__inlineParagraph__J9PuS";
export const listItemHeading = "ContentsBased__listItemHeading__WTZYW";
export const medium = "500";
export const paragraph = "ContentsBased__paragraph__wQSx-";
export const paragraphTitle = "ContentsBased__paragraphTitle__9fAJk font-faces__sansBold__vF+EN font-faces__sans__uCf65";
export const regular = "400";
export const sans = "'sans'";
export const section = "ContentsBased__section__2U6EQ";
export const sectionAnchor = "ContentsBased__sectionAnchor__3qkYH";
export const sectionTitle = "ContentsBased__sectionTitle__Q9m69 font-faces__atlasGroteskMedium__1ilbx font-faces__atlasGrotesk__rYPJr";
export const semibold = "600";
export const serif = "'serif'";
export const tableOfContentsWrapper = "ContentsBased__tableOfContentsWrapper__qIwdZ";
export const toTopLink = "ContentsBased__toTopLink__PYL06";
export const transitionTitle = "ContentsBased__transitionTitle__Bsuf7 font-faces__atlasGroteskMedium__1ilbx font-faces__atlasGrotesk__rYPJr";